import ReactDOM from 'react-dom';

export const handleCloseClick = function (event, root) {
    event.preventDefault();
    ReactDOM.unmountComponentAtNode(root);
};
